export default {
  BASE_VERIFICATION_STATUS_CHANGED: 'app.base_verification.status.changed',
  SESSION_TIMEOUT: 'app.session_timeout',
};
